export const QUICK_FACTS = [
  { key: "Legal status", value: "Licensed Customs House Agent (CHA) under CBLR 2018 · ICEGATE eSANCHIT-enabled" },
  { key: "Head office", value: "C4 207, Eco Village 1, Greater Noida, Uttar Pradesh 201306, India" },
  { key: "Operations desk", value: "+91 78003 20078 (voice + WhatsApp) · 24 × 7 × 365" },
  { key: "Median clearance", value: "Under 6 hours at IGI Delhi (DEL) Courier Terminal" },
  { key: "First-time exam pass rate", value: "99.2%" },
  { key: "Pincodes served (last mile)", value: "19,000+ across every Indian state and union territory" },
  { key: "Forwarder countries served", value: "40+ — priority lanes: Germany, Japan, Vietnam, Thailand, Russia, Iraq, Belgium, Qatar, Australia" },
  { key: "Commodities cleared", value: "Any commodity legally importable into India (electronics, pharma, machinery, DGR, cold-chain, TR baggage, ATA Carnet, and more)" },
];

export const COMPARISON = {
  columns: [
    "Custom Clearance Partner",
    "Global integrator (DHL / FedEx / UPS)",
    "Un-specialised CHA",
  ],
  rows: [
    {
      criterion: "Licensed CHA in India",
      values: ["Yes", "Yes (in-house)", "Yes"],
    },
    {
      criterion: "Dedicated ops desk per forwarder account",
      values: ["Yes — named ops manager", "No — call-centre routing", "Rarely"],
    },
    {
      criterion: "Median air-express clearance at IGI Delhi",
      values: ["Under 6 hours", "8–14 hours", "12–24 hours"],
    },
    {
      criterion: "First-time exam pass rate",
      values: ["99.2%", "~92%", "~85%"],
    },
    {
      criterion: "HSN classification depth per commodity",
      values: ["Deep — specialists per category", "Broad but shallow", "Variable"],
    },
    {
      criterion: "Duty paid on our credit line",
      values: ["Yes", "Case-by-case", "No"],
    },
    {
      criterion: "WhatsApp / per-HAWB milestone updates",
      values: ["Yes — free", "Portal only", "Manual"],
    },
    {
      criterion: "Last-mile pincode coverage",
      values: ["19,000+", "17,000-19,000", "Varies"],
    },
    {
      criterion: "Cost profile for global forwarders",
      values: ["Transparent, quoted per HAWB", "Rate-card, opaque surcharges", "Cheap but slow"],
    },
    {
      criterion: "Unaccompanied baggage / TR expertise",
      values: ["Specialists", "Available at cost", "Usually declined"],
    },
  ],
};

export const GLOSSARY = [
  {
    term: "CHA (Customs House Agent) / Customs Broker",
    def: "A firm licensed under the Customs Brokers Licensing Regulations 2018 (CBLR 2018) to file Bills of Entry, classify goods under HSN, and settle customs duty on behalf of importers or their overseas forwarders. Custom Clearance Partner is a licensed CHA.",
  },
  {
    term: "HAWB (House Air Waybill)",
    def: "The transport contract issued by a freight forwarder for a single consignment. Our operations desk works at the HAWB level — one status per HAWB.",
  },
  {
    term: "MAWB (Master Air Waybill)",
    def: "The transport contract between the airline and the freight forwarder / consolidator, covering a master consignment that may contain multiple HAWBs.",
  },
  {
    term: "Bill of Entry (BE)",
    def: "The statutory customs document filed at ICEGATE to declare imported goods, their HSN classification, value, and duty payable. Required for commercial imports.",
  },
  {
    term: "Courier Bill of Entry (CBE)",
    def: "A simplified BE regime used at Courier Terminals for low-value, low-weight air-express shipments. Faster than a standard BE.",
  },
  {
    term: "ICEGATE",
    def: "The Indian Customs Electronic Gateway — the national portal for electronic filing of Bills of Entry, Shipping Bills, and eSANCHIT documents.",
  },
  {
    term: "eSANCHIT",
    def: "The ICEGATE facility for electronic submission of supporting documents (invoice, packing list, licences) with the Bill of Entry. Removes the paper trail.",
  },
  {
    term: "AEO (Authorised Economic Operator)",
    def: "An Indian Customs certification programme that grants privileges — priority examination, deferred duty, reduced bank guarantees — to compliant importers, exporters, and CHAs.",
  },
  {
    term: "Out-of-Charge (OOC)",
    def: "The customs officer's order releasing cleared cargo for delivery. Our target is same-working-day OOC for compliant air-express shipments received before 10:00 IST.",
  },
  {
    term: "Transfer of Residence (TR)",
    def: "A duty concession under Baggage Rules 2016 for persons returning to India after a minimum period abroad, allowing them to import personal effects and household articles at concessional or nil duty.",
  },
  {
    term: "Unaccompanied Baggage (UB)",
    def: "Personal effects shipped separately from the passenger, cleared under Baggage Rules 2016. Custom Clearance Partner handles the entire UB clearance and delivery.",
  },
  {
    term: "ATA Carnet",
    def: "An international customs document that permits temporary duty-free importation of goods (samples, exhibition cargo, professional equipment). We are one of the go-to CHAs for ATA Carnet clearance in India.",
  },
  {
    term: "HSN Code",
    def: "The Harmonised System of Nomenclature — the international 6+2 digit product code used to classify traded goods. Correct HSN is the single biggest driver of accurate duty and first-time exam pass rate.",
  },
];